// extracted by mini-css-extract-plugin
export default {"container":"container__wHhDX","financialInstitution":"financialInstitution__NV0VU","desktop":"desktop__SWmqC","text":"text__ubdWa","logo":"logo__eHsrc"};